var map = {
	"./y2020/I.mp3": 9335,
	"./y2020/akane.mp3": 2637,
	"./y2020/ha.mp3": 5081,
	"./y2020/haruka.mp3": 5636,
	"./y2020/myou.mp3": 1742,
	"./y2020/nagi.mp3": 6348,
	"./y2020/namari.mp3": 6953,
	"./y2020/soku.mp3": 2832,
	"./y2020/tomoe.mp3": 3659,
	"./y2020/torico.mp3": 8687,
	"./y2020/you.mp3": 9233,
	"./y2020/yuki.mp3": 5873,
	"./y2021/Kage-Sakasama.mp3": 2114,
	"./y2021/Kieteiku.mp3": 5227,
	"./y2021/Kondaku.mp3": 6399,
	"./y2021/Kyo.mp3": 6123,
	"./y2021/Kyoei.mp3": 9910,
	"./y2021/Sakuran.mp3": 7651,
	"./y2021/Sen-Nuritubusu.mp3": 217,
	"./y2021/Tran.mp3": 6970,
	"./y2021/bobaku.mp3": 537,
	"./y2021/eisya.mp3": 1993,
	"./y2021/kakera.mp3": 2678,
	"./y2021/koku.mp3": 4925,
	"./y2021/kowaku.mp3": 8327,
	"./y2021/kyokan.mp3": 7380,
	"./y2021/kyomei.mp3": 5555,
	"./y2021/kyosyu.mp3": 9545,
	"./y2021/paragram.mp3": 2128,
	"./y2021/toho.mp3": 6595,
	"./y2021/yuen.mp3": 4086,
	"./y2021/zankyo.mp3": 6479,
	"./y2022/imada-kurikaesu.mp3": 5585,
	"./y2022/konohi.mp3": 3648,
	"./y2022/kugi-hai.mp3": 7867,
	"./y2022/kyoei.mp3": 4992,
	"./y2022/tada-omou.mp3": 3298,
	"./y2022/ugokenai-ten.mp3": 7100,
	"./y2023/bokyaku.mp3": 3445,
	"./y2023/kiri-no-naka.mp3": 6554,
	"./y2023/rakka-hoko.mp3": 7130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3766;